export const SEARCH_ELECTRIC_INVOICES = "SEARCH_ELECTRIC_INVOICES";
export const SEARCH_ELECTRIC_INVOICES_SUCCESS =
  "SEARCH_ELECTRIC_INVOICES_SUCCESS";
export const SEARCH_ELECTRIC_INVOICES_FAILURE =
  "SEARCH_ELECTRIC_INVOICES_FAILURE";

export const SEND_EMAIL_INVOICE = "SEND_EMAIL_INVOICE";
export const SEND_EMAIL_INVOICE_SUCCESS = "SEND_EMAIL_INVOICE_SUCCESS";
export const SEND_EMAIL_INVOICE_FAILURE = "SEND_EMAIL_INVOICE_FAILURE";
